import { combineReducers } from "@reduxjs/toolkit"
import { reducer as formReducer } from "redux-form"

const reducers = combineReducers({
  form: formReducer,
  user: [{
    "id": 1,
    "firstName": "qwe",
    "lastName": "qwe",
    "email": "qwe@qwe.com",
    "status": "active",
    "userId": "xyz1"
  },
  {
    "id": 2,
    "firstName": "vishal",
    "lastName": "bashetti",
    "email": "vishal@ethersys.ai",
    "status": "active",
    "userId": "xyz2"
  },
  {
    "id": 4,
    "firstName": "Ether",
    "lastName": "Ether",
    "email": "sales@etherdaylight.com",
    "status": "active",
    "userId": "xyz3"
  }]
})

export default reducers
